<template>
  <v-main
    id="pages"
    :class="$vuetify.theme.dark ? 'info' : 'info'"
  >
    <v-img
      :class="{
        'v-image--sm': this.$vuetify.breakpoint.smAndDown,
        'v-image--md': this.$vuetify.breakpoint.mdAndDown
      }"
      :src="require(`@/my/assets/backgrounds/${src || 'rythm.jpg'}`)"
      gradient="to top, rgba(38, 40, 46, .5), rgba(38, 40, 46, .5)"
      min-height="100%"
    >
      <router-view />
    </v-img>
  </v-main>
</template>

<script>
  export default {
    name: 'PagesCoreView',

    data: () => ({
      srcs: {
        '/': 'rythm.jpg',
      },
    }),

    computed: {
      src () {
        return this.srcs[this.$route.path]
      },
    },
  }
</script>

<style lang="sass">
  #pages
    > .v-content__wrap > .v-image
      padding-top: 64px
      padding-bottom: 88px

    .v-responsive__sizer
      display: none

    .v-image--md
      padding: 188px 0

    .v-image--sm
      padding: 96px 0 188px 0

    .v-responsive__content
      margin-left: auto !important
</style>
